// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"394":"867c9388","803":"d032f6f9"}[chunkId] + ".chunk.js";
};